module.exports = __webpack_public_path__ + "img/KWD.bfcc9d82.svg";